module.exports = __webpack_public_path__ + "static/media/ProviderReferralInfusion.a4725e68.txt";